import styled from "styled-components"

export const StyledFooterLogo = styled.div`
  width: 186px;
  height: 48px;
  @media only screen and (max-width: 768px) {
    margin-bottom: 35px;
  }
`
